<template>
  <loading-full v-if="isLoading"></loading-full>
  <header>
    <h1 class="logo" @click="goHome()"></h1>
    <ul class="faq_area">
      <li><a href="https://www.gomlab.com/faq/?product=GOMMAX" target="_blank">{{ $t('HeaderTxt.TXT1') }}</a></li>
      <li><a href="https://www.gomlab.com/support/" target="_blank">{{ $t('HeaderTxt.TXT2') }}</a></li>
    </ul>
    <div class="r_area">
      <div class="wrap_select">
        <div class="bx_select" :class="{on : isActive}" @click="isActive = !isActive">
          <button type="button">{{txt}}</button>
          <ul>
            <li v-for="(lng, idx) in langList" :key="idx" @click="selectChange(idx)" :class="{on: txt === lng.nativeName}">{{lng.nativeName}}</li>
          </ul>
        </div>
      </div>
      <a class="btn" href="https://www.gomlab.com/gommixmax-video-editing/" target="_blank">{{ $t('HeaderTxt.TXT3') }}</a>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import LoadingFull from '@/components/include/LoadingFull.vue'

export default {
  data () {
    return {
      txt: '한국어',
      isActive: false,
      langList: [
        { code: 'ko', nativeName: '한국어' },
        { code: 'en', nativeName: 'English' },
        { code: 'ja', nativeName: '日本語​' }
      ],
      lang: '',
      isLoading: false
    }
  },
  components: {
    LoadingFull
  },
  computed: {
    ...mapGetters([
      'getLang',
      'getUserIp',
      'getNowPath'
    ]),
    checkIp () {
      return this.getUserIp
    }
  },
  watch: {
    checkIp (val) {
      this.langPh(val)
    }
  },
  created () {
    this.langPh()
  },
  methods: {
    ...mapMutations([
      'setPageNum',
      'setNowPath'
    ]),
    langPh (val) {
      if (localStorage.getItem('lang') !== '') {
        this.lang = localStorage.getItem('lang') ?? val
      }
      this.langList.forEach(item => {
        if (this.lang === item.code) {
          this.txt = item.nativeName
          this.$i18next.changeLanguage(item.code)
        }
      })
    },
    goHome () {
      this.$router.push({
        path: '/',
        title: 'Gom Mix Max'
      })
      this.setPageNum(0)
      this.setNowPath('/')
    },
    selectChange (idx) {
      this.isLoading = true
      this.txt = this.langList[idx].nativeName
      this.$store.dispatch('setLang', this.langList[idx].code)
        .then(() => {
          this.$router.go()
          this.$i18next.changeLanguage(this.getLang)
        })
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variable.scss';
@import '@/styles/_svgicon.scss';

.wrap_select {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  width: 120px;
  height: 47px;
  z-index: 5;
  .bx_select {
    width: 100%; height: 100%;
    position: absolute;
    top: 0; left: 0;
    &.on {
      button {
        background-image: svg_arr_up('bbb');
      }
      ul {
        display: block;
      }
    }
    button {
      width: 100%; height:100%;
      padding:0 25px 0 25px;
      line-height: 46px;
      font-size: 15px;
      font-weight: 700;
      text-align: left;
      background: svg_arr_down('bbb') no-repeat ;
      background-size: 15px 15px;
      background-position: right 10px bottom 50%;
      @include ellipsis;
      &:disabled{
        cursor: default;
      }
    }
    ul {
      display: none;
      width: 100%; height: auto;
      padding: 13px 10px;
      border-radius: 10px;
      box-shadow: 0px 4px 16px rgba(43, 61, 85, 0.1);
      background-color: $white;
      box-sizing: border-box;
      li {
        font-size: 15px;
        line-height: 46px;
        padding: 0 15px;
        cursor: pointer;
        font-weight: 700;
        @include ellipsis;
        box-sizing: border-box;
        &:hover, &.on {
          background-color: #F7F7F7;
          border-radius: 10px;
        }
      }
    }
  }
}
</style>
